import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useGetRecentViewsQuery } from "@api/apiV6";
import _ from "lodash";
import { Div, Image } from "@components/Generics.react";

import ArticleCarousel from "@components/ArticleCarousel.react";
import { settings } from "@config/settings/app.settings";

export default function GeneralHome(props) {
    const taggedList = useSelector((state) => state.articles.taggedList);
    const articlesList = useSelector((state) => state.articles.list);
    const user = useSelector((state) => state.auth.user);
    const { data: recents, isSuccess } = useGetRecentViewsQuery();

    const selectedTags = _.filter(
        settings.home[user.stage].carousels,
        (tag) => taggedList[tag]?.articles.length > 0
    );
    const linkedHeaders = settings.home[user.stage].linkedHeaders;
    const { t } = useTranslation("common");
    const isPortrait = window.innerHeight > window.innerWidth;

    // ========================= Render Function =================================
    return (
        <>
            {linkedHeaders.length > 0 &&
                _.map(linkedHeaders, (headerImg, idx) => {
                    if (headerImg.link.includes("http"))
                        return (
                            <a
                                href={headerImg.link}
                                target="_blank"
                                rel="noreferrer"
                                key={`linkedheader-${idx}`}
                            >
                                <Div padded={isPortrait} gutter>
                                    <Image fluid rounded src={headerImg.src} />
                                </Div>
                            </a>
                        );
                    else
                        return (
                            <NavLink
                                to={headerImg.link}
                                key={`linkedheader-${idx}`}
                            >
                                <Div padded={isPortrait} gutter>
                                    <Image fluid rounded src={headerImg.src} />
                                </Div>
                            </NavLink>
                        );
                })}
            {isSuccess &&
                recents.article.length > 0 &&
                settings.home[user.stage].recents && (
                    <Div
                        key={`recent-carousel`}
                        compact
                        padTop
                        rounded
                        smoke={!isPortrait}
                        gutter={!isPortrait}
                        small
                    >
                        <ArticleCarousel
                            header={t("home.recently")}
                            articles={recents.article}
                        />
                    </Div>
                )}
            {settings.home[user.stage].newly && (
                <Div
                    key={`newly-carousel`}
                    compact
                    padTop
                    rounded
                    smoke={!isPortrait}
                    gutter={!isPortrait}
                    small
                >
                    <ArticleCarousel
                        header={t("home.newly")}
                        articles={_.reverse(
                            _.sortBy([..._.values(articlesList)], "createdAt")
                        )}
                    />
                </Div>
            )}
            {_.map(selectedTags, (tag, carouselIndex) => {
                return (
                    <Div
                        key={`carousel-index-${carouselIndex}`}
                        compact
                        padTop
                        rounded
                        smoke={!isPortrait}
                        gutter={!isPortrait}
                        small
                    >
                        <ArticleCarousel
                            header={
                                !_.startsWith(t(`tags.${tag}`), "tags")
                                    ? t(`tags.${tag}`)
                                    : tag
                            }
                            libLink={`/tags/${tag}`}
                            articles={taggedList[tag]?.articles}
                        />
                    </Div>
                );
            })}
        </>
    );
}
